export const NAVBAR_OPEN = 'NAVBAR_OPEN';
export const SET_ACTIVE_REPORT = 'SET_ACTIVE_REPORT';
export const SET_FORM_SELECTIONS = 'SET_FORM_SELECTIONS';
export const SET_SUBMITTED_VALUES = 'SET_SUBMITTED_VALUES';
export const SET_PROPERTIES_GROUP_BY = 'SET_PROPERTIES_GROUP_BY';

const reducer = (state, action) => {
  switch (action.type) {
    case NAVBAR_OPEN:
      return {
        ...state,
        navbarOpen: action.payload
      };
    case SET_ACTIVE_REPORT:
      return {
        ...state,
        activeReport: action.payload
      };
    case SET_FORM_SELECTIONS:
      return {
        ...state,
        formSelections: { ...state.formSelections, ...action.payload }
      };
    case SET_SUBMITTED_VALUES:
      return {
        ...state,
        submittedValues: { ...state.submittedValues, ...action.payload }
      };
    case SET_PROPERTIES_GROUP_BY:
      return {
        ...state,
        propertiesGroupBy: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
